import { isDef } from "@redotech/util/checks";
import classnames from "classnames";
import { CSSProperties } from "react";
import * as skeletonCss from "./skeleton.module.css";

export function SkeletonBlock() {
  return <div className={skeletonCss.skeleton} />;
}

export function SkeletonAnimatedBlock() {
  return <div className={skeletonCss.animatedSkeletonBlock} />;
}

export function SkeletonText({
  length,
  constrainWidth,
  classNames,
  height,
}: {
  length: number | "full";
  constrainWidth?: boolean;
  animated?: boolean;
  classNames?: string;
  height?: string;
}) {
  const isFull = length === "full";
  return (
    <span
      className={classnames(skeletonCss.skeletonText, classNames)}
      style={{
        height,
        ...(isFull && { width: "100%", display: "block" }),
        ...(constrainWidth && { maxWidth: "100%", display: "block" }),
      }}
    >
      {isFull ? "\u00A0" : "_".repeat(length)}
    </span>
  );
}

export function AnimatedSkeletonBlock({
  height,
  width,
  className,
}: {
  height?: string;
  width?: string;
  className?: string;
}) {
  let style: CSSProperties | undefined;
  if (isDef(width)) {
    style = { ...style, width };
  }
  if (isDef(height)) {
    style = { ...style, height };
  }

  return (
    <span
      className={classnames(skeletonCss.skeletonText, className)}
      style={style}
    >
      _
    </span>
  );
}
